<template>
    <div class="messageBg">
        <div class="wrap">
            <div class="hmTit text-center wow fadeInDown">
                <h2 class="hmTitCn f40 color_f">发表您的留言：</h2>
            </div>
            <div class="messBox wow fadeInUp">
                <el-form :model="msgForm" :rules="rules" ref="msgForm" class="msgForm">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="24" :md="12">
                            <el-form-item prop="your_name">
                                <el-input class="msgInput" v-model="msgForm.your_name" placeholder="您的姓名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12">
                            <el-form-item>
                                <el-input class="msgInput" v-model="msgForm.your_position" placeholder="您的职位"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12">
                            <el-form-item>
                                <el-input class="msgInput" v-model="msgForm.email" placeholder="您的邮箱"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12">
                            <el-form-item prop="phone">
                                <el-input class="msgInput" v-model="msgForm.phone" placeholder="您的电话"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24">
                            <el-form-item prop="msg">
                                <el-input
                                    class="msgInput"
                                    type="textarea"
                                    :rows="3"
                                    placeholder="您想说的话~"
                                    v-model="msgForm.msg">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-button class="msgBtn" type="primary" @click="submitForm('msgForm')">提交</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
    import common from '@/api/common'
    export default {
        name: 'Message',
        data(){
            //校验手机号
            const isMobileNumber = (rule, value, callback) => {
                if (!value) {
                    return new Error("请输入电话号码");
                } else {
                    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
                    const isPhone = reg.test(value);
                    value = Number(value); //转换为数字
                    if (typeof value === "number" && !isNaN(value)) {//判断是否为数字
                    value = value.toString(); //转换成字符串
                    if (value.length < 0 || value.length > 12 || !isPhone) { //判断是否为11位手机号
                        callback(new Error("手机号码格式如:138xxxx8754"));
                    } else {
                        callback();
                    }
                    } else {
                    callback(new Error("请输入电话号码"));
                    }
                }
            };
            return{
                msgForm: {
                    your_name: '',
                    your_position: '',
                    email: '',
                    phone: '',
                    msg: ''
                },
                rules: {
                    your_name: [
                        { required: true, message: '请输入您的姓名', trigger: 'blur' }
                    ],
                    // your_position: [
                    //     { required: true, message: '请输入您的职位', trigger: 'blur' }
                    // ],
                    // email: [
                    //     { required: true, message: '请输入您的邮箱', trigger: 'blur' },
                    //     { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                    // ],
                    phone: [
                        { required: true, message: '请输入您的电话', trigger: 'blur' },
                        { validator: isMobileNumber, message: '请输入正确的手机号', trigger: "blur"}
                    ],
                    msg: [
                        { required: true, message: '请输入您想说的话', trigger: 'blur' }
                    ]
                }
            }
        },
        mounted () {

        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // console.log(valid,this.msgForm)
                        const params = this.msgForm;
                        common.message(params).then((res) => {
                            if (res.code === 1) {
                                this.$toast(res.msg)
                            } else {
                                this.$toast(res.msg)
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }    
</script>
<style lang="scss" scoped>
$mainColor:#C39D6C;
.messageBg{
    padding: .6rem 0;
    background: url(~@/assets/images/index/box6-bg.png) center center no-repeat;
    background-size: cover;
    overflow: hidden;
}
.messBox{
    max-width: 860px;
    margin: 0 auto;
    margin-top: .4rem;
}
.msgForm{
    .el-form-item{
        .msgInput{
            ::v-deep .el-input__inner{
                border-radius: 0;
                height: 50px;
            }
        }
        ::v-deep .el-form-item__error{
            color: #FFFFFF;
        }
        &.is-error{
            ::v-deep .el-input__inner,
            ::v-deep .el-textarea__inner{
                border-color: $mainColor;
            }
        }
    }
    .msgBtn{
        display: block;
        max-width: 100%;
        width: 260px;
        height: 50px;
        background: #7A5930;
        border: none;
        margin: 0 auto;
    }
}
@media screen and (max-width:1200px){
    
}
@media screen and (max-width:767px){
    
}
</style>